import { render, staticRenderFns } from "./InactiveMemberOrderIframe.vue?vue&type=template&id=ef46a242&"
import script from "./InactiveMemberOrderIframe.vue?vue&type=script&lang=ts&"
export * from "./InactiveMemberOrderIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports